var map = {
	"./reflection/level/Bronze.png": 64316,
	"./reflection/level/Diamond.png": 72314,
	"./reflection/level/Emerald.png": 83618,
	"./reflection/level/Gold.png": 68582,
	"./reflection/level/Platinum.png": 53248,
	"./reflection/level/Ruby.png": 44776,
	"./reflection/level/Silver.png": 39599,
	"./reflection/level/Wish.png": 35629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79000;